export const encryptNumber = (ctn: string) => {
  const decrypted = ctn.substring(2);
  const parts = decrypted.match(/.{1,4}/g);

  const randomDigitsStart = getRandomDigits();
  const randomDigitsEnd = getRandomDigits().substring(1);

  return `${randomDigitsStart}-${parts[0]}-${parts[1]}-${parts[2]}${randomDigitsEnd}`;
}

export const getRandomDigits = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
}

